import { ScoreMode, ScoreModeType } from './scorecard-constants';
import { ScoreStatusType } from './scoring-engine-constants';

/** Single-source semantic tone class for a score value, mode-aware (health bands differ from Alexa bands). */
export const getScoreToneClass = (score: number, mode: ScoreModeType): string => {
  if (mode === ScoreMode.ALEXA) {
    if (score >= 80) return 'tone-success';
    if (score >= 60) return 'tone-brand';
    if (score >= 40) return 'tone-warning';
    return 'tone-danger';
  }
  if (score >= 90) return 'tone-success';
  if (score >= 70) return 'tone-brand';
  if (score >= 60) return 'tone-warning';
  return 'tone-danger';
};

export const getStatusToneClass = (status: ScoreStatusType): string => {
  switch (status) {
    case 'pass':
      return 'tone-success';
    case 'warning':
      return 'tone-warning';
    case 'fail':
    default:
      return 'tone-danger';
  }
};
